// extracted by mini-css-extract-plugin
export var locationCard = "_op-0";